const { YB_PAY_TYPES } = require('../../utils/constant')

function buildParkingPayPayload({ orderId, isWechatPayPark, isAli, loginCode }) {
  if (isWechatPayPark) {
    if (isAli) {
      throw new Error('该车场仅支持微信支付，请使用微信扫码打开')
    }
    if (!loginCode) {
      throw new Error('未获取到公众号登录信息，请重新扫码')
    }
    return { orderId, loginCode }
  }

  if (isAli) {
    return {
      orderId,
      channelCode: YB_PAY_TYPES.YB_ALIPAY_USER_SCAN
    }
  }

  if (!loginCode) {
    throw new Error('未获取到公众号登录信息，请重新扫码')
  }
  return {
    orderId,
    channelCode: YB_PAY_TYPES.YB_WECHAT_OFFIACCOUNT,
    loginCode
  }
}

function normalizeWechatPayData(data) {
  const responseData = typeof data === 'string' ? JSON.parse(data) : data
  const payData = responseData && responseData.prePay
    ? responseData.prePay
    : responseData
  if (!payData || typeof payData !== 'object') {
    throw new Error('微信支付参数为空')
  }

  const normalizedPayData = {
    ...payData,
    package: payData.package || payData.packageValue
  }

  const requiredFields = [
    'appId',
    'timeStamp',
    'nonceStr',
    'package',
    'signType',
    'paySign'
  ]
  if (requiredFields.some(field => !normalizedPayData[field])) {
    throw new Error('微信支付参数不完整')
  }
  return normalizedPayData
}

module.exports = {
  buildParkingPayPayload,
  normalizeWechatPayData
}
